import { render, staticRenderFns } from "./GestionJournal.vue?vue&type=template&id=3d57f6d5&scoped=true&"
import script from "./GestionJournal.vue?vue&type=script&lang=js&"
export * from "./GestionJournal.vue?vue&type=script&lang=js&"
import style0 from "./GestionJournal.vue?vue&type=style&index=0&id=3d57f6d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d57f6d5",
  null
  
)

export default component.exports